import { useMutate } from 'restful-react'
import { CreateUserBody } from './interfaces'

const useCreateUser = () => {
    return useMutate<any, any, any, CreateUserBody>('POST', '/user/register/lgpduser')
}

export default useCreateUser
